import * as React from 'react'

import { CodeEditor, CodeEditorProps } from './CodeEditor'

export type CodeExampleProps = CodeEditorProps

export function CodeExample({ ...props }: CodeExampleProps) {
  return <CodeEditor readOnly {...props} initialCode={props.initialCode || props.code} />
}
